// src/components/Header.jsx
import React from "react";
import styled from "styled-components";
import CLIDENavigation from "./navigations";

const HeaderContainer = styled.header`
  background: #ffffff;
  padding: 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
`;

const Header = ({ themeColor, navMenuEnabled }) => {
  return (
    <HeaderContainer>
      <CLIDENavigation
        themeColor={themeColor}
        navMenuEnabled={navMenuEnabled}
      />
    </HeaderContainer>
  );
};

export default Header;
